import React, { useEffect, useState } from "react";
import Spinner from "../../../components/_common/Spinner";
import { useAppDispatch, useAppSelector } from "../../../redux/store/storehooks";
import { getMiscellaneousFunctions } from "../../../api/api";
import { UpdateMiscellaneousFunctions } from "../../../redux/reducers/MiscellaneousFunctionsSlice";
import { errorNotify } from "../../../services/toast.notification";

export interface InputProps {
  url: any,
}

const SqlServer = ({url}: InputProps) => {
     
    const myStore = useAppSelector((state: any) => state)
    const dispatch = useAppDispatch();
    const [isloading,setIsLoading] = useState(true);
  
    const _getSql = (url:string,func:number,fromdate:string,todate:string) => {
      getMiscellaneousFunctions(url,func,fromdate,todate)
      .then((result:any) => {
        let jsonResult = JSON.parse(result.data.json);
        dispatch(UpdateMiscellaneousFunctions({ sqlavailable:jsonResult.version}))
        setIsLoading(false);
      })
      .catch((error:any) => {
        console.log(error);
        errorNotify(error.response.data.errorMessage,undefined,5000)
      }) 
      
      
  }
  
    useEffect(() => {
        _getSql(url,3,'','');
    }, [])

    let data = myStore.miscellaneousList.sqlavailable;
    return (
    <div className="tab-content-padding">

      {
      
      isloading === false && (
        <>
        <div className="row" >
            <p>
                version:           
                {data[0].version}             
            </p>
        </div>
       
  </>
      )}

      {isloading === true && (
        <Spinner />
      )}

    </div>
  )

};

export default SqlServer;
